import { RequestStatus } from '@shared/model/request';
import { StatusOption } from './types';

export const ORDER_STATUSES: StatusOption[] = [
    {
        label: 'На рассмотрении',
        value: RequestStatus.New,
    },
    {
        label: 'Согласовано',
        value: RequestStatus.OrderForming,
    },
    {
        label: 'Отклонено',
        value: `${RequestStatus.Request_reject},${RequestStatus.Canceled}`,
    },
];
